import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function SuccessIcon(props) {
    return (
        <SvgIcon {...props}>
            <g clipPath="url(#clip0)" fill="none">
                <circle cx="16" cy="16" r="15.25" stroke="#EDA821" strokeWidth="1.5" />
                <path d="M23 12.3037L14.5238 20.7799L10.5334 16.8077" stroke="#EDA821" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </SvgIcon>
    );
}

SuccessIcon.defaultProps = {
    viewBox: '0 0 32 32'
};

export default SuccessIcon;
